<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('signature.pageTitle') }}</h1>
    </div>
    <ts-card>
      <ts-card-wrapper>
        <form class="form-horizontal">
          <div class="row form-group">
            <label class="col-md-2 col-form-label">
              {{ $t('signature.copyFrom') }}
              <i class="fa fa-spinner spin" v-if="fetch"></i>
            </label>
            <div class="col-md-3">
              <select
                class="form-control"
                v-model="model.from_branch"
                :disabled="fetch"
              >
                <option value>{{ $t('select') }}</option>
                <option
                  v-for="(branch, index) in branches"
                  :value="branch.branch_id"
                  :key="index"
                >
                  {{ branch.branch_name_en }}
                </option>
              </select>
            </div>
          </div>
          <div class="row form-group">
            <label
              class="col-md-2 col-form-label required"
            >
              {{ $t('signature.signatureType') }}
            </label>
            <div class="col-md-3">
              <select
                class="form-control"
                v-model="model.signature_type"
                :class="{ 'is-invalid': errors.has('signature_type') }"
              >
                <option value>{{ $t('select') }}</option>
                <option value="Card">Card</option>
                <option value="Report">Report</option>
              </select>
              <div class="invalid-feedback" v-if="errors.has('signature_type')">
                {{ errors.first('signature_type') }}
              </div>
            </div>
          </div>
          <div class="row form-group">
            <label class="col-md-2 col-form-label">{{
              $t('signature.positionKh')
            }}</label>
            <div class="col-md-3">
              <input
                v-model.trim="model.position_kh"
                type="text"
                class="form-control"
                :class="{ 'is-invalid': errors.has('position_kh') }"
              />
              <div class="invalid-feedback" v-if="errors.has('position_kh')">
                {{ errors.first('position_kh') }}
              </div>
            </div>
          </div>
          <div class="row form-group">
            <label
              class="col-md-2 col-form-label required"
              >{{ $t('signature.position') }}</label
            >
            <div class="col-md-3">
              <input
                v-model.trim="model.position"
                type="text"
                class="form-control"
                :class="{ 'is-invalid': errors.has('position') }"
              />
              <div class="invalid-feedback" v-if="errors.has('position')">
                {{ errors.first('position') }}
              </div>
            </div>
          </div>
          <div class="row form-group">
            <label class="col-md-2 col-form-label">{{
              $t('signature.signedKh')
            }}</label>
            <div class="col-md-3">
              <input
                v-model.trim="model.signed_by_kh"
                type="text"
                class="form-control"
                :class="{ 'is-invalid': errors.has('signed_by_kh') }"
              />
              <div class="invalid-feedback" v-if="errors.has('signed_by_kh')">
                {{ errors.first('signed_by_kh') }}
              </div>
            </div>
          </div>
          <div class="row form-group">
            <label
              class="col-md-2 col-form-label required"
              >{{ $t('signature.signBy') }}</label
            >
            <div class="col-md-3">
              <input
                v-model.trim="model.signed_by"
                type="text"
                class="form-control"
                :class="{ 'is-invalid': errors.has('signed_by') }"
              />
              <div class="invalid-feedback" v-if="errors.has('signed_by')">
                {{ errors.first('signed_by') }}
              </div>
            </div>
          </div>
          <div class="row form-group">
            <label
              class="col-md-2 col-form-label required"
              >{{ $t('signature.signatureFile') }}</label
            >
            <div class="col-md-3">
              <ts-button color="primary" @click="$refs.file.click()">{{
                $t('signature.browseFile')
              }}</ts-button>
              <input
                type="file"
                ref="file"
                style="display: none"
                accept="image/x-png, image/gif, image/jpeg"
                @change="onFileChange"
              />
              <div class="text-danger" v-if="errors.has('file')">
                {{ errors.first('file') }}
              </div>
              <img id="signature" :src="priview" alt />
            </div>
          </div>
          <div class="row form-group">
            <label class="col-md-2"></label>
            <div class="col-md-3 text-right">
              <ts-button :waiting="waiting" @click="onSave" color="primary">
                {{ $t('save') }}
              </ts-button>
            </div>
          </div>
        </form>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'
import { debounce } from 'lodash'
export default {
  name: 'signature',
  data() {
    return {
      model: {
        id: 0,
        from_branch: '',
        position: '',
        signed_by: '',
        signatures: '',
        file: '',
        position_kh: '',
        signed_by_kh: '',
        signature_type: 'Card',
      },
      errors: new Errors(),
      branches: [],
      priview:
        'https://cdn.pixabay.com/photo/2012/04/11/11/16/signature-27485_960_720.png',
      waiting: false,
    }
  },
  created() {
    this.fetchBranch()
  },
  computed: {
    ...mapState('signature', ['resources']),
  },
  methods: {
    fetchBranch() {
      this.fetch = true
      this.$store
        .dispatch('signature/getBranch')
        .then((response) => {
          this.branches = response.data
          this.fetchData()
          this.fetch = false
        })
        .catch((error) => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.fetch = false
        })
    },
    onFileChange(e) {
      let file = e.target.files[0]
      if (file instanceof File || file instanceof Blob) {
        this.model.file = file
      }

      let reader = new FileReader()
      reader.addEventListener(
        'load',
        function () {
          this.priview = reader.result
        }.bind(this),
        false
      )
      if (file) {
        if (/\.(jpe?g|png)$/i.test(file.name)) {
          reader.readAsDataURL(file)
        }
      }
    },
    fetchData() {
      this.$store
        .dispatch(
          'signature/fetch',
          Object.assign({
            signature_type: this.model.signature_type,
            from_branch: this.model.from_branch ? this.model.from_branch : '',
          })
        )
        .then(() => {
          this.clearInput()
          if (this.resources.length > 0) {
            this.model.id = this.resources[0].id ? this.resources[0].id : 0
            this.model.position = this.resources[0].position
            this.model.signed_by = this.resources[0].signed_by
            this.model.signatures = this.resources[0].signatures
            this.model.position_kh = this.resources[0].position_kh
            this.model.signed_by_kh = this.resources[0].signed_by_kh
            this.model.signature_type = this.resources[0].signature_type
            this.priview =
              this.resources[0].signatures +
              '&api_token=' +
              this.$store.getters.accessToken
          }
        })
        .catch((error) => {
          this.$toasted.error(error.message)
          this.fetch = false
        })
    },
    clearInput() {
      this.model.id = 0
      this.model.position = ''
      this.model.signed_by = ''
      this.model.signatures = ''
      this.model.position_kh = ''
      this.model.signed_by_kh = ''
      this.priview =
        'https://cdn.pixabay.com/photo/2012/04/11/11/16/signature-27485_960_720.png'
    },
    onSave() {
      this.errors = new Errors()
      this.waiting = true
      let formData = new FormData()
      formData.append('id', this.model.id)
      formData.append('from_branch', this.model.from_branch)
      formData.append('position', this.model.position)
      formData.append('signed_by', this.model.signed_by)
      formData.append('signatures', this.model.signatures)
      formData.append('position_kh', this.model.position_kh)
      formData.append('signed_by_kh', this.model.signed_by_kh)
      formData.append('signature_type', this.model.signature_type)
      formData.append('file', this.model.file)
      this.$store
        .dispatch('signature/store', formData)
        .then((response) => {
          this.$refs.file.value = ''
          this.model.file = ''
          this.fetchData()
          this.$toasted.success(response.message)
          this.errors = new Errors()
        })
        .catch((error) => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
  },
  watch: {
    'model.signature_type': debounce(function () {
      this.fetchData()
    }, 500),
    'model.from_branch': debounce(function () {
      this.fetchData()
    }, 500),
  },
}
</script>

<style lang="css" scoped>
#signature {
  height: 100px;
  margin: 16px 0;
}
</style>
